<template>
  <div class="dropdown">
    <ul class="dropdown-list">
      <li v-for="(item, index) in items" :key="index" class="dropdown-item">
        <a href="javascript:void(0);" @click="navigate(item.link)">
          {{ item.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    navigate(link) {
      this.$emit("navigate", link);
    },
  },
};
</script>

<style scoped>
.dropdown {
  width: 249px;
  height: 178px;
  border-radius: 20px;
  background-color: #ffffff;
  position: relative;
  padding: 19px 23px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
}

.dropdown-list {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  margin: 0;
}

.dropdown-item {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.dropdown-item:hover {
  color: #ff6d0a;
}

.dropdown-item a,
.dropdown-item router-link {
  text-decoration: none;
  color: inherit;
}

.dropdown-item a:hover,
.dropdown-item router-link:hover {
  text-decoration: none;
}

@media (max-width: 853px) {
  .dropdown {
    padding: 16px 20px 0px 20x;
    box-shadow: none;
  }
}
</style>
